// Sidebar.js
import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import {
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Collapse,
    Divider,
    useTheme,
    useMediaQuery,
    Menu,
    MenuItem,
    TextField,
    Button,
    styled,
    Badge,
    Tooltip,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import {
    Logout,
    Person,
    BarChart,
    ExpandMore,
    Brightness4,
    Brightness7,
    Home,
    People,
    Settings,
    History,
    AllInbox,
    RecentActors,
    Monitor,
    QueryStats,
    DynamicFeed,
    Workspaces,
    DarkMode,
    LightMode,
    PermIdentity,
    Bolt,
    Phone,
    NotificationAdd,
    MoreVert,
    ChatBubble,
    QuestionAnswer,
    LibraryBooks,
    Quiz,
    Campaign,
    Ballot,
} from '@mui/icons-material';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import { useDarkMode } from '../Context/DarkMode';
 
import { useNavigate, useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import TokenAuth from '../Auth/TokenAuth';
import { global_link, socket_base_url, socketiopath } from './Globallink';
import { Snackbar, Alert } from '@mui/material';
import WebSocketContext from '../Context/WebSocket';
 
const collapsedDrawerWidth = 83;
const expandedDrawerWidth = 195;
const drawerWidth = 240;
 
const Sidebar = ({ children }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [activeSubmenu, setActiveSubmenu] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const location = useLocation();
    const currentPath = location.pathname;
    const [phoneNumber, setPhoneNumber] = useState('');
    const { isDarkMode, setIsDarkMode } = useDarkMode();
    const [appAnchorEl, setAppAnchorEl] = useState(null);
    const appMenuOpen = Boolean(appAnchorEl);
    const authToken = process.env.AUTH_TOKEN;
    const [name, setName] = useState('');
    const [level, setLevel] = useState('');
    const [extension, setExtension] = useState('');
    const api = axios.create({ baseURL: global_link });
    const authyToken = localStorage.getItem(authToken);
    const [userLevel, setUserLevel] = useState("");
    const [notificationMessage, setNotificationMessage] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [notificationCount, setNotificationCount] = useState(0);
    const [refreshCount, setRefreshCount] = useState(0);
    const [openExpirySnackbar, setOpenExpirySnackbar] = useState(false);
    const [expiryNotification, setExpiryNotification] = useState('');
    const [state, setState] = useState({ open: false, vertical: 'top', horizontal: 'center' });
    const { vertical, horizontal } = state;
 
    // Use WebSocket context — single shared socket, no duplicate
    const { socket, user_id } = useContext(WebSocketContext);
    const notificationSoundRef = useRef(new Audio('/Tones/notification.mp3'));
    const [autodialerBg, setAutodialerBg] = useState('inherit');
 
    // ── Track which chat is currently open (set by Chat.jsx via custom event) ─
    const activeChatUserRef = useRef('');
    useEffect(() => {
        const handler = (e) => { activeChatUserRef.current = e.detail; };
        window.addEventListener('activeChatUser', handler);
        return () => window.removeEventListener('activeChatUser', handler);
    }, []);
 
    const playNotificationSound = () => {
        notificationSoundRef.current.play()
            .then(() => console.log('Sound played successfully!'))
            .catch((error) => console.error('Failed to play sound:', error));
    };
 
    const handleAppMenuClose = () => setAppAnchorEl(null);
    const toggleDarkMode = () => setIsDarkMode((prevMode) => !prevMode);
    const handleSidebarToggle = () => setIsSidebarOpen(!isSidebarOpen);
    const toggleSubmenu = (menu) => setActiveSubmenu(activeSubmenu === menu ? '' : menu);
    const handleAppMenuClick = (event) => setAppAnchorEl(event.currentTarget);
    const toggleMenu = (event) => setAnchorEl((prevAnchorEl) => (prevAnchorEl ? null : event.currentTarget));
 
    const [openRight, setRightOpen] = React.useState(true);
    const handleDrawerOpen = () => setRightOpen(true);
    const handleDrawerClose = () => setRightOpen(false);
    const navigate = useNavigate();
 
    useEffect(() => {
        const authyToken = localStorage.getItem(authToken);
        if (authyToken != null) {
            const decodedToken = jwtDecode(authyToken);
            const userLevel = decodedToken.user_level;
            const expirationTime = decodedToken.exp * 1000;
            const currentTime = Date.now();
            if (currentTime > expirationTime) {
                localStorage.removeItem(authToken);
            } else {
                setUserLevel(userLevel);
            }
        }
    }, []);
 
    const headers = {
        'Authorization': `Bearer ${authyToken}`,
        'Content-Type': 'application/json',
    };
 
    const MotificationCount = async () => {
        try {
            const response = await api.get('/chat/notificationcount', {
                headers,
                withCredentials: true,
            });
            setNotificationCount(response.data);
        } catch (error) {
            console.error('Error fetching notification count:', error);
            setNotificationCount(0);
        }
    };
 
    useEffect(() => {
        MotificationCount();
    }, []);
 
    useEffect(() => {
        const fetchExpiryInfoIfNeeded = async () => {
            if (userLevel === 'supervisor') {
                try {
                    const headers = {
                        Authorization: `Bearer ${authyToken}`,
                        'Content-Type': 'application/json',
                    };
                    const response = await api.get('/user/usercallconfigs', { headers, withCredentials: true });
 
                    const dueDateStr = response.data.dueDate;
                    const currentDateStr = response.data.currentDate;
 
                    if (!dueDateStr || !currentDateStr) {
                        console.warn('Missing dueDate or currentDate in response');
                        return;
                    }
 
                    const dueDate = new Date(dueDateStr);
                    const currentDate = new Date(currentDateStr);
 
                    if (isNaN(dueDate.getTime()) || isNaN(currentDate.getTime())) {
                        console.error('Invalid date format received');
                        return;
                    }
 
                    const normalize = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
                    const normDue = normalize(dueDate);
                    const normCurrent = normalize(currentDate);
                    const dayDiff = Math.floor((normDue.getTime() - normCurrent.getTime()) / (1000 * 60 * 60 * 24));
 
                    const formattedDue = dueDate.toLocaleDateString('en-US', {
                        year: 'numeric', month: 'long', day: 'numeric',
                    });
 
                    let shouldShow = false;
                    let message = "";
 
                    if (dayDiff < 0) {
                        message = (<>Subscription Expired on <strong>{formattedDue}</strong></>);
                        shouldShow = true;
                    } else if (dayDiff <= 7) {
                        message = (<>Subscription Will Expire on <strong>{formattedDue}</strong></>);
                        shouldShow = true;
                    }
 
                    if (shouldShow) {
                        setExpiryNotification(message);
                        setOpenExpirySnackbar(true);
                    }
                } catch (error) {
                    console.error('Error fetching expiry info:', error);
                }
            }
        };
        fetchExpiryInfoIfNeeded();
    }, [userLevel, authyToken]);
 
    // ── NEW_MESSAGE notification — stale closure fixed via activeChatUserRef ──
    useEffect(() => {
        if (!socket) return;
        const handleNewMessage = async (message) => {
            // Only notify if the message is for this user AND the sender's chat isn't currently open
            if (message.receiver_id === user_id && message.sender_id !== activeChatUserRef.current) {
                try {
                    const authyToken = localStorage.getItem(authToken);
                    const headers = {
                        Authorization: `Bearer ${authyToken}`,
                        'Content-Type': 'application/json',
                    };
                    MotificationCount();
                    const response = await api.get(`/user/getuser/${message.sender_id}`, { headers, withCredentials: true });
                    setNotificationMessage(`New Chat from ${response.data.user_name}`);
                    setOpenSnackbar(true);
                    playNotificationSound();
                } catch (error) {
                    console.error('Failed to fetch user info:', error);
                }
            }
        };
        socket.on('NEW_MESSAGE', handleNewMessage);
        return () => socket.off('NEW_MESSAGE', handleNewMessage);
    }, [socket, user_id]); // activeChatUserRef is a ref — intentionally not in deps
 
    // ── WhatsApp notification ─────────────────────────────────────────────────
    useEffect(() => {
        if (!socket) return;
        const handleWhatsApp = () => {
            setNotificationMessage('You have a New WhatsApp Chat');
            setOpenSnackbar(true);
            playNotificationSound();
        };
        socket.on('WHATSAPP_RECIEVE_EVENT', handleWhatsApp);
        return () => socket.off('WHATSAPP_RECIEVE_EVENT', handleWhatsApp);
    }, [socket]);
 
    useEffect(() => {
        const handleUpdateNotification = () => setRefreshCount((prev) => prev + 1);
        window.addEventListener('updateMainNotificationCount', handleUpdateNotification);
        return () => window.removeEventListener('updateMainNotificationCount', handleUpdateNotification);
    }, []);
 
    useEffect(() => {
        MotificationCount();
    }, [refreshCount]);
 
    const navItems = [
        { title: 'Home', icon: (<Tooltip title="Home" placement="right"><Home sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/' },
        { title: 'Call Log', icon: (<Tooltip title="Call Log" placement="right"><History sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/calls' },
        { title: 'Dispositions', icon: (<Tooltip title="Dispositions" placement="right"><AllInbox sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/dispositions' },
        { title: 'Ticketing', icon: (<Tooltip title="Ticketing" placement="right"><DynamicFeed sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/ticketing' },
        { title: 'Contacts', icon: (<Tooltip title="Contacts" placement="right"><RecentActors sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/contacts' },
        { title: 'Chat', icon: (<Tooltip title="Chat" placement="right"><QuestionAnswer sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/chat' },
        { title: 'Users', icon: (<Tooltip title="Users" placement="right"><People sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/users' },
        { title: 'Analytics', icon: (<Tooltip title="Analytics" placement="right"><BarChart sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/analytics' },
        { title: 'Integrations', icon: (<Tooltip title="Integrations" placement="right"><Workspaces sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/integrations' },
        { title: 'Monitoring', icon: (<Tooltip title="Monitoring" placement="right"><QueryStats sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/monitoring' },
        { title: 'Campaigns', icon: (<Tooltip title="Campaigns" placement="right"><Campaign sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/campaigns' },
        { title: 'Scripts', icon: (<Tooltip title="Scripts" placement="right"><LibraryBooks sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/scripts' },
        { title: 'FAQs', icon: (<Tooltip title="FAQs" placement="right"><Quiz sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/faqs' },
        { title: 'Forms', icon: (<Tooltip title="Forms" placement="right"><Ballot sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/forms' },
        { title: 'Settings', icon: (<Tooltip title="Settings" placement="right"><Settings sx={{ fontSize: '1.2rem' }} /></Tooltip>), path: '/settings' },
    ];
 
    const filteredNavItems = navItems.filter(item => {
        if (userLevel === 'agent') {
            const agentItems = ['Home', 'Call Log', 'Dispositions', 'Contacts', 'Interactions', 'Ticketing', 'Chat', 'Integrations', 'Campaigns', 'Scripts', 'FAQs', 'Forms'];
            return agentItems.includes(item.title);
        } else if (userLevel === 'supervisor') {
            const agentItems = ['Home', 'Call Log', 'Dispositions', 'Contacts', 'Interactions', 'Ticketing', 'Chat', 'Integrations', 'Analytics', 'Monitoring', 'Campaigns', 'Scripts', 'FAQs', 'Forms'];
            return agentItems.includes(item.title);
        } else if (userLevel === 'admin') {
            const agentItems = ['Home', 'Call Log', 'Dispositions', 'Contacts', 'Interactions', 'Ticketing', 'Chat', 'Integrations', 'Users', 'Analytics', 'Monitoring', 'Campaigns', 'Scripts', 'FAQs', 'Forms'];
            return agentItems.includes(item.title);
        }
        return true;
    });
 
    const dialerTabChange = (tab_no) => {
        if (tab_no === 'campaign_mode') {
            window.dispatchEvent(new CustomEvent('campaignMode', { detail: 'campaignMode' }));
        } else {
            window.dispatchEvent(new CustomEvent('dialerTabChange', { detail: tab_no }));
        }
    };
 
    const updateUserLive = () => {
        const extension = sessionStorage.getItem('extension');
        if (!extension || !socket) return;
        socket.emit('END_SEND_USER_LIVE', { extension });
    };
 
    // ── Logout — socket events fire BEFORE redirect ───────────────────────────
    const handleLogout = () => {
        try {
            // Fire socket events first — before any storage is cleared
            if (socket) {
                socket.emit('USER_LOGOUT');
                socket.disconnect();
            }
            updateUserLive();
 
            // Preserve user preferences
            const darkMode = localStorage.getItem('darkMode');
            const language = localStorage.getItem('language');
            const themeVal = localStorage.getItem('theme');
 
            localStorage.clear();
            sessionStorage.clear();
 
            if (darkMode !== null) localStorage.setItem('darkMode', darkMode);
            if (language !== null) localStorage.setItem('language', language);
            if (themeVal !== null) localStorage.setItem('theme', themeVal);
 
            // Clear IndexedDB
            if ('indexedDB' in window) {
                try {
                    ['callRecordings', 'callLogs', 'chatHistory', 'conversations'].forEach(dbName => {
                        const request = indexedDB.deleteDatabase(dbName);
                        request.onsuccess = () => console.log(`Database ${dbName} deleted`);
                        request.onerror = (e) => console.warn(`Failed to delete ${dbName}:`, e.target.error);
                        request.onblocked = () => console.warn(`${dbName} deletion blocked`);
                    });
                } catch (dbError) {
                    console.warn('Error clearing IndexedDB:', dbError);
                }
            }
 
            // Clear Cache API
            if ('caches' in window) {
                caches.keys().then(cacheNames => {
                    cacheNames.forEach(cacheName => caches.delete(cacheName).catch(() => {}));
                }).catch(() => {});
            }
 
            // Clear cookies
            try {
                document.cookie.split(';').forEach(cookie => {
                    const [name] = cookie.trim().split('=');
                    if (name) {
                        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
                        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`;
                        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${window.location.hostname}`;
                    }
                });
            } catch (cookieError) {
                console.warn('Error clearing cookies:', cookieError);
            }
 
            // Unregister service workers
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.getRegistrations()
                    .then(registrations => registrations.forEach(r => r.unregister().catch(() => {})))
                    .catch(() => {});
            }
 
            setTimeout(() => {
                window.location.href = '/login';
            }, 100);
 
        } catch (error) {
            console.error('Error during logout:', error);
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = '/login';
        }
    };
 
    const convertToCamelCase = (text) => {
        return text
            .toLowerCase()
            .split(/[^a-zA-Z0-9]+/)
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
 
    const userInfo = () => {
        const authyToken = localStorage.getItem(authToken);
        const headers = {
            'Authorization': `Bearer ${authyToken}`,
            'Content-Type': 'application/json',
        };
        api.get('/user/user', { headers, withCredentials: true })
            .then(response => {
                setName(convertToCamelCase(response.data.user_name));
                setLevel(convertToCamelCase(response.data.user_level));
                setExtension(response.data.user_extension);
            })
            .catch(error => console.error(error));
    };
 
    useEffect(() => {
        userInfo();
    }, []);
 
    useEffect(() => {
        const handleNotifyAutoDialer = (event) => setAutodialerBg(event.detail);
        window.addEventListener('notifyAutoDialer', handleNotifyAutoDialer);
        return () => window.removeEventListener('notifyAutoDialer', handleNotifyAutoDialer);
    }, []);

    return (
        <Box sx={{ display: 'flex' }}>
            <TokenAuth/>
            <AppBar
                position="fixed"
                sx={{
                    width: isSmallScreen ? '100%' : `calc(100% - ${isSidebarOpen ? expandedDrawerWidth : collapsedDrawerWidth}px)`,
                    ml: isSmallScreen ? 0 : `${isSidebarOpen ? expandedDrawerWidth : collapsedDrawerWidth}px`,
                    bgcolor: 'background.appbar',
                    color: 'text.primary',
                    boxShadow: 'none',
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <Toolbar variant="dense">
                    <IconButton 
                        edge="start" 
                        onClick={handleSidebarToggle}
                        sx={{ color: 'text.primary' }}
                    >
                     <DensityMediumIcon sx={{ fontSize: '1.2rem' }} />
                    </IconButton>
                    <Box sx={{ flexGrow: 1 }} />
                    <Typography sx={{marginRight:'11px', fontSize:'0.9rem'}}>{name} | {extension}</Typography>
                    <IconButton onClick={() => dialerTabChange(0)} size="small" sx={{color:'inherit'}}>
                        <Phone sx={{ fontSize: '1.2rem' }} />
                    </IconButton>
                    <IconButton onClick={() => MotificationCount()} component={Link} to="/chat" size="small" sx={{color:'inherit'}}>
                        <Badge badgeContent={notificationCount > 0 ? notificationCount : null} color="error">
                            <ChatBubble sx={{ fontSize: '1.2rem' }} /></Badge>
                    </IconButton>
                    <IconButton onClick={() => dialerTabChange('campaign_mode')} size="small" sx={{ color:'inherit' }}>
                    <Bolt sx={{ fontSize: '1.2rem', color: autodialerBg }} />
                    </IconButton>
                     <IconButton onClick={() => dialerTabChange(3)} size="small" sx={{color:'inherit'}}>
                        <Settings sx={{ fontSize: '1.2rem' }} />
                    </IconButton>
                    <IconButton onClick={handleAppMenuClick} aria-controls={appMenuOpen ? "app-menu" : undefined} aria-expanded={appMenuOpen ? "true" : undefined} aria-haspopup="true" size="small" sx={{color:'inherit'}}>
                    <Person sx={{ fontSize: '1.2rem', color:'inherit'}}   />
                    </IconButton>
                    <IconButton onClick={toggleDarkMode} size="small" sx={{color:'inherit'}}>
                        {isDarkMode ? <LightMode sx={{ fontSize: '1.2rem'}} /> : <DarkMode sx={{ fontSize: '1.2rem'}} />}
                    </IconButton>

          <Divider />
                    
                </Toolbar>
            </AppBar>

            <Drawer
                variant={isSmallScreen ? 'temporary' : 'permanent'}
                open={isSidebarOpen}
                onClose={handleSidebarToggle}
                sx={{
                    width: isSidebarOpen ? expandedDrawerWidth : collapsedDrawerWidth,
                    '& .MuiDrawer-paper': {
                        width: isSidebarOpen ? expandedDrawerWidth : collapsedDrawerWidth,
                        bgcolor: 'background.sidebar',
                        borderRight: '1px solid',
                        borderColor: 'divider',
                        overflowX: 'hidden',
                        transition: theme.transitions.create('width'),
                    },
                }}
            >

                <Toolbar sx={{ minHeight: '48px !important', cursor: 'pointer',}}>
                    <Typography variant="subtitle2" sx={{ textDecoration: "none !important",color: "inherit", flexGrow: 1, textAlign: 'center', fontWeight: 550, fontSize: '1.4rem'}}   
                    component={Link}
                    to="/" >
                        {isSidebarOpen && 'Call Suite CX'}
                    </Typography>
                </Toolbar>


<Menu
  id="app-menu"
  anchorEl={appAnchorEl}
  open={appMenuOpen}
  onClose={handleAppMenuClose}
  MenuListProps={{
    "aria-labelledby": "app-button",
  }}
  slotProps={{
    paper: {
      sx: {
        width: 165,
        bgcolor: 'background.appbar',
        boxShadow: 'none', 
        mt: 1.5, 
        marginLeft: '10px !important',
        border: `1px solid rgba(207, 211, 212, 0.2)`,
      }
    }
  }}
>
  {/* Fix: Change Typography variant to avoid p tag and use sx for styling */}
  <Typography 
    variant="body2" 
    component="div" 
    sx={{
      paddingBottom: '5px', 
      textAlign: 'center'
    }}
  >
    <Typography 
      variant="subtitle1" 
      component="div" 
      sx={{fontSize: '17px', padding: '0px!important'}}
    >
      {name}
    </Typography>
    ( {level} - {extension} )
  </Typography>
  <Divider sx={{ marginBottom:'5px', marginTop:'5px'}}/>
  <MenuItem component={Link} to="/profile">
    <PermIdentity/> <Typography sx={{ml:1}}> Profile</Typography>
  </MenuItem>
  <MenuItem onClick={handleLogout}>
    <Logout/> <Typography sx={{ml:1}}> Logout</Typography>
  </MenuItem>
</Menu>
                <Divider />

                <List sx={{ px: 2, marginTop: '14px' }}>
    {filteredNavItems.map((item, index) => (
        <Box key={index}>
            <ListItem
                button
                onClick={() => item.submenu ? toggleSubmenu(item.title) : navigate(item.path)}
                sx={{
                    borderRadius: '8px',
                    mb: 0.4,
                    bgcolor: currentPath === item.path ? 'action.hover' : 'inherit',
                    '&:hover': {
                        bgcolor: 'action.hover',
                        cursor: 'pointer'
                    },
                }}
            >
                <ListItemIcon sx={{ color: 'text.primary', minWidth: 35 }}>
                    {item.icon}
                </ListItemIcon>
                {isSidebarOpen && (
                    <>
                        <ListItemText
                            primary={item.title}
                            primaryTypographyProps={{
                                variant: 'body2',
                                sx: { fontWeight: 500, fontSize: '1.0rem' }
                            }}
                        />
                        {item.submenu && (
                            <ExpandMore
                                sx={{
                                    fontSize: '1.1rem',
                                    transform: activeSubmenu === item.title ? 'rotate(180deg)' : 'none',
                                    transition: '0.2s',
                                }}
                            />
                        )}
                    </>
                )}
            </ListItem>
            {isSidebarOpen && item.submenu && activeSubmenu === item.title && (
                <Collapse in={true} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        {item.submenu.map((subItem, subIndex) => (
                            <ListItem
                                button
                                key={subIndex}
                                onClick={() => navigate(subItem.path)}
                                sx={{
                                    pl: 4,
                                    borderRadius: '8px',
                                    mb: 0.5,
                                    bgcolor: currentPath === item.path ? 'action.hover' : 'inherit',
                                    '&:hover': {
                                        bgcolor: 'action.hover',
                                        cursor: 'pointer'
                                    },
                                }}
                            >
                                <ListItemText
                                    primary={subItem.title}
                                    primaryTypographyProps={{
                                        variant: 'body2',
                                        sx: { fontWeight: 400, fontSize: '0.9rem' }
                                    }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Collapse>
            )}
        </Box>
    ))}
</List>
   </Drawer>

    <Snackbar open={openSnackbar} anchorOrigin={{ vertical, horizontal }} autoHideDuration={null} onClose={() => setOpenSnackbar(false)}>
    {/* <Alert onClose={() => setOpenSnackbar(false)} severity="success" component={Link} to="/chat" sx={{ width: '100%' }}> */}
    <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
    {notificationMessage}
    </Alert>
    </Snackbar>

        <Snackbar
    open={openExpirySnackbar}
    anchorOrigin={{ vertical, horizontal }}
    autoHideDuration={null}
    >
<Alert
  severity="error"
  sx={{
    width: '100%',
    fontWeight: 'bold',
    animation: 'pulse 2s infinite',
    '@keyframes pulse': {
      '0%': { boxShadow: '0 0 0 0 rgba(244, 67, 54, 0.7)' },
      '70%': { boxShadow: '0 0 0 10px rgba(244, 67, 54, 0)' },
      '100%': { boxShadow: '0 0 0 0 rgba(244, 67, 54, 0)' },
    }
  }}
>
  {expiryNotification}
</Alert>
    </Snackbar>

        </Box>

    );
};

export default Sidebar;
